<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        class="white--text"
        @click="items=[]; getSalesOrders(txtOrderNo, txtName, txtEmail, cboStatus, txtMinOrderDate, txtMaxOrderDate, cboCourierId, cboSort); rightDrawer=false;"
      >
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" lazy-validation @submit.prevent="">
              <v-text-field
                v-model="txtName"
                label="Name"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtEmail"
                label="Email"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-text-field
                v-model="txtOrderNo"
                label="Order No"
                @keyup.enter="clickFilter()"
              ></v-text-field>
              <v-select
                v-model="cboStatus"
                :items="statuses"
                label="Status"
              ></v-select>
              <v-menu
                ref="dtMinOrderDate"
                :close-on-content-click="false"
                v-model="dtMinOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMinOrderDate"
                  label="Min Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMinOrderDate" no-title @input="dtMinOrderDate = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="dtMaxOrderDate"
                :close-on-content-click="false"
                v-model="dtMaxOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMaxOrderDate"
                  label="Max Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMaxOrderDate" no-title @input="dtMaxOrderDate = false"></v-date-picker>
              </v-menu>
              <v-select
                v-model="cboCourierId"
                :items="couriers"
                item-text="courierName"
                item-value="courierId"
                label="Courier"
              ></v-select>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="title"
                item-value="key"
                label="Sorting"
              ></v-select>
              <v-btn
                @click="clickFilter()"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter(); getSalesOrders(txtOrderNo, txtName, txtEmail, cboStatus, txtMinOrderDate, txtMaxOrderDate, cboCourierId, cboSort); rightDrawer=false;">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-tabs
          color="secondary"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs"
          :key="index"
          :to="'/orders/' + item.key"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-list two-line>
        <div v-for="(item, index) in items" :key="item.salesOrderNo">
          <v-list-tile
            :key="item.salesOrderNo"
            avatar
            :to="'/order/' + item.salesOrderNo"
            @click="items = []"
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-icon v-if="item.deliveryStatus === 'sent'" medium color="green darken-2">check_circle_outline</v-icon>
                <v-icon v-else medium>hourglass_empty</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">
                {{ item.salesOrderNo }}
                <span v-if="item.paymentStatus === 'chargeback'" class="body-1 ml-2 font-weight-bold red--text">CHARGEBACK</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">
                {{ item.shippingTitle }} {{ item.shippingFirstName }} {{ item.shippingLastName }} <span v-if="item.courierName">- ({{ item.courierName }} - {{ item.serviceCode }})</span>
                <span v-if="item.deliveryStatus !== 'pending'" :class="(item.deliveryStatus === 'pending' ? 'orange--text text--lighten-2' : (item.deliveryStatus === 'partial' ? 'orange--text' : (item.deliveryStatus === 'sent' ? 'green--text' : ''))) + ' font-weight-bold ml-2'">[{{ item.deliveryStatus | allCaps }}]</span>
                <span v-if="item.isPrinted === '1'" class="blue--text text--darken-1 font-weight-bold ml-2">[PRINTED]</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.customerLocation }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>{{ item.displayDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-action-text>
              <strong>{{ item.currencySign + formatPrice(item.totalSales + item.deliveryCost + item.importTariff, item.currencyDecimals, item.currencyDecimalSign, item.currencyThousandSeparator) }}</strong>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </div>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No sales yet
            </div>
          </v-flex>
        </template>
      </v-list>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
              light
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
              light
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import moment from 'moment'
import axios from 'axios'
import router from '../router'
import { EventBus } from '../main'

export default {
  props: [
    'status'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      autoloadInterval: null,
      frmValid: true,
      txtOrderNo: '',
      txtName: '',
      txtEmail: '',
      cboStatus: '',
      statuses: ['all', 'in-progress', 'shipped'],
      dtMinOrderDate: false,
      dtMaxOrderDate: false,
      txtMinOrderDate: '',
      txtMaxOrderDate: '',
      cboCourierId: '',
      couriers: [],
      cboSort: null,
      sorts: [
        {
          key: 'paidDateTime:desc',
          title: 'Latest'
        },
        {
          key: 'paidDateTime:asc',
          title: 'From beginning'
        }
      ],
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      tabs: [
        {
          key: 'in-progress',
          title: 'In-progress'
        },
        {
          key: 'shipped',
          title: 'Shipped'
        },
        {
          key: 'all',
          title: 'All'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    var _this = this
    EventBus.$on('logout', function () {
      clearInterval(_this.autoloadInterval)
    })
    // window.addEventListener('scroll', this.detectBottomOfWindow)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.detectBottomOfWindow)
  },
  mounted () {
    this.openDrawerForDesktop()

    // init
    this.clearFilter()
    this.txtOrderNo = this.$route.query.order_no || ''
    this.txtEmail = this.$route.query.email || ''
    this.txtName = this.$route.query.name || ''
    this.txtMinOrderDate = this.$route.query.min_date || ''
    this.txtMaxOrderDate = this.$route.query.max_date || ''
    this.cboCourierId = this.$route.query.courier || ''
    this.cboSort = this.$route.query.sort || ''

    this.getSalesOrders(this.txtOrderNo, this.txtName, this.txtEmail, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboSort)
    this.listCouriers()

    var _this = this
    _this.autoloadInterval = setInterval(function () {
      _this.items = []
      _this.getSalesOrders(_this.txtOrderNo, _this.txtName, _this.txtEmail, _this.cboStatus, _this.txtMinOrderDate, _this.txtMaxOrderDate, _this.cboCourierId, _this.cboSort)
    }, (5 * 60 * 1000))
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getSalesOrders(this.txtOrderNo, this.txtName, this.txtEmail, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboSort, (val - 1) * this.listLimit)
    }
  },
  methods: {
    detectBottomOfWindow: function () {
      // console.log(document.documentElement.scrollTop + window.innerHeight) - 48
      // console.log(document.documentElement.offsetHeight)
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.offsetHeight - 5)

      if (bottomOfWindow) {
        if (this.listTotal > this.items.length) {
          this.getSalesOrders(this.txtOrderNo, this.txtName, this.txtEmail, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboSort, this.items.length)
        }
      }
    },
    listCouriers: function () {
      var _this = this
      var url = process.env.VUE_APP_API_ROOT + '/v1/shipping/couriers/CHN'
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.couriers = resp.data.data
          } else {
            console.log('unable to list couriers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              clearInterval(_this.autoloadInterval)
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              clearInterval(_this.autoloadInterval)
              console.log(error.response)
            }
          }
        })
    },
    clickFilter: function () {
      this.items = []
      this.rightDrawer = false
      if (this.cboStatus === this.status) {
        this.getSalesOrders(this.txtOrderNo, this.txtName, this.txtEmail, this.cboStatus, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboSort)
      } else {
        router.push('/orders/' + this.cboStatus + '?order_no=' + this.txtOrderNo + '&name=' + this.txtName + '&email=' + this.txtEmail + '&min_date=' + this.txtMinOrderDate + '&max_date=' + this.txtMaxOrderDate + '&courier=' + this.cboCourierId + '&sort=' + this.cboSort)
      }
    },
    getSalesOrders: function (orderNo = '', name = '', email = '', status = '', minCreatedDate = '', maxCreatedDate = '', courierId = '', sort = '', offset = 0) {
      var _this = this
      var params = ''

      switch (status) {
        case 'shipped':
          params = 'delivery_status=sent,delivered'
          break
        case 'in-progress':
          params = 'payment_status=paid,credit&delivery_status=pending,partial'
          break
        default:
          params = 'payment_status=paid,credit'
      }

      if (courierId === null) {
        courierId = ''
      }

      if (minCreatedDate !== '') {
        minCreatedDate = moment.utc(minCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }
      if (maxCreatedDate !== '') {
        maxCreatedDate = moment.utc(maxCreatedDate + ' 00:00:00' + _this.profile.gmtTimezone).format('YYYY-MM-DD HH:mm:ss')
      }

      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        params += '&order_no=' + orderNo + '&name=' + name + '&email=' + email + '&courier_id=' + courierId + '&min_created_datetime=' + minCreatedDate + '&max_created_datetime=' + maxCreatedDate + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales?' + params)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              for (var c = 0; c < resp.data.data.length; ++c) {
                // inject displayDateTime
                if (resp.data.data[c].paymentStatus === 'paid' || resp.data.data[c].paymentStatus === 'credit') {
                  resp.data.data[c].displayDateTime = resp.data.data[c].paidDateTime
                } else {
                  resp.data.data[c].displayDateTime = resp.data.data[c].createdDateTime
                }

                resp.data.data[c].total = resp.data.data[c].cacheTotalSales + resp.data.data[c].deliveryCost + resp.data.data[c].importTariff
                resp.data.data[c].customerLocation = resp.data.data[c].shippingCityName + ', ' + resp.data.data[c].shippingCountryName
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
            } else {
              console.log('unable to load sales order list: ' + resp.data.message)
            }
            _this.isLoadingItems = false
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                clearInterval(_this.autoloadInterval)
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                clearInterval(_this.autoloadInterval)
                _this.showAlert(error)
              }
              _this.loading = false
              _this.isLoadingItems = false
            }
          })
      }
    },
    clearFilter () {
      this.cboStatus = this.status
      if (typeof this.cboStatus === 'undefined' || this.cboStatus === '') {
        this.cboStatus = 'in-progress'
      }
      this.txtOrderNo = ''
      this.txtEmail = ''
      this.txtName = ''
      this.txtMinOrderDate = ''
      this.txtMaxOrderDate = ''
      this.cboCourierId = ''
      this.cboSort = ''
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
